import { QueryKey } from "@tanstack/react-query";
import { PaginationParams } from "../type";

export const TEMPLATE_KEYS = {
  TEMPLATES: "templates",
  GET_TEMPLATES: (params?: PaginationParams): QueryKey => [
    TEMPLATE_KEYS.TEMPLATES,
    "list",
    params,
  ],
  GET_TEMPLATE: (templateId: string): QueryKey => [
    TEMPLATE_KEYS.TEMPLATES,
    templateId,
  ],
  RULES: "rules",
  GET_RULES: (params?: PaginationParams): QueryKey => [
    TEMPLATE_KEYS.RULES,
    params,
  ],
  GET_RULE: (ruleId: string): QueryKey => [
    TEMPLATE_KEYS.RULES,
    ruleId,
  ],
};
